import { Youtube } from "lucide-react";
import { CountUp } from "@/components/CountUp";

export const YoutubeSection = () => (
    <div className="fade-in" data-testid="youtube-section">
      <h2 className="text-4xl sm:text-6xl font-bold mb-6 text-center" data-testid="youtube-title">
        Contenu YouTube
      </h2>
      <p className="text-lg sm:text-xl text-white/80 text-center max-w-3xl mx-auto mb-12">
        Découvrez les bases du CRT et quelques concepts ICT
      </p>

      <div className="max-w-4xl mx-auto space-y-8">
        {/* YouTube Embed */}
        <div className="aspect-video rounded-2xl overflow-hidden border-2 border-white/20 shadow-2xl">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/NFLKuDqhYCk"
            title="Chaîne YouTube 700S ICT"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            data-testid="youtube-embed"
          ></iframe>
        </div>

        {/* Subscribe Button */}
        <div className="text-center">
          <a
            href="https://www.youtube.com/channel/UCpeq1_l-3P9wSBeaFN8lq3Q"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-red-600 text-white font-bold text-lg rounded-lg hover:bg-red-700 hover:scale-105 transition-all shadow-xl"
            data-testid="youtube-subscribe-button"
          >
            <Youtube size={28} />
            S'abonner à la chaîne
          </a>
        </div>

        {/* Subscriber Count */}
        <div className="flex justify-center mt-12">
          <div className="p-8 rounded-xl bg-white/5 border border-white/10 text-center min-w-[200px]">
            <h4 className="text-4xl font-bold mb-2"><CountUp value={6000} testId="stat-subscribers-count" /></h4>
            <p className="text-white/70">Abonnés</p>
          </div>
        </div>
      </div>
    </div>
);
